import React from "react";
import PageHero from "@/components/PageHero";
import { Container } from "@/components/shared";

const sections = [
  { h: "About these terms", p: "By using Made in Boston you agree to these terms. The site is run independently by a private citizen and is provided in good faith, as is." },
  { h: "Listings", p: "Makers are responsible for the accuracy of their own listings. Every listing is reviewed before going live, and we may decline or remove any listing at our discretion. A listing is not an endorsement." },
  { h: "Membership and prices", p: "Membership prices are shown for information. In this preview, no card payment is taken; a plan can be assigned to your account so that badges and placement can be seen. Paid billing will be introduced later." },
  { h: "Enquiries and introductions", p: "We pass enquiries and consider introductions in good faith but cannot guarantee a reply, a match, or the conduct of any party we connect you with." },
  { h: "Advertising", p: "Adverts are clearly labelled and do not imply endorsement by any authority. We keep them clear of the core history and legal pages." },
  { h: "Independence", p: "This is not a council website, not Boston 400, and not a government initiative. Nothing here should be read as official." },
  { h: "Liability", p: "To the extent the law allows, we are not liable for losses arising from use of the site or from dealings between users. Nothing here excludes liability that cannot lawfully be excluded." },
];

export default function Terms() {
  return (
    <div>
      <PageHero kicker="Terms" title="Terms of use" intro="The plain rules of the crossing. Read them once; they are short." />
      <section className="py-16 sm:py-24">
        <Container>
          <div className="max-w-3xl mx-auto space-y-8">
            {sections.map((s) => (
              <div key={s.h}>
                <h2 className="font-serif text-xl text-[#003366] mb-2">{s.h}</h2>
                <p className="font-sans text-base text-[#1B2430] leading-relaxed">{s.p}</p>
              </div>
            ))}
            <p className="font-sans text-sm text-[#505A68] pt-6 border-t border-[#D6D3CB]">
              An independent project. Not a local authority website.
            </p>
          </div>
        </Container>
      </section>
    </div>
  );
}
